import React from 'react'
import apiRest from '../../../services/apiRest'

// material-ui
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormLabel from '@material-ui/core/FormLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'

const statusPeople = ['Ativo', 'Inativo', 'Pendente', 'Desligado']

// types
interface Props {
  printState: any
  matches: boolean
  churchId: string
  setOpenModalPrint: any
  isOpenModalPrint: any
  onChangePrintState: any
  setShowDetailsInPrint: (value: React.SetStateAction<boolean>) => void
}

export const Resume = ({
  printState,
  matches,
  churchId,
  setOpenModalPrint,
  isOpenModalPrint,
  onChangePrintState,
}: Props) => {
  const onClickPrint = async () => {
    const url = '/people/pdf'
    const popup = window.open('', '_blank')
    if (popup) {
      if (!matches) {
        popup.document.write('arquivo baixado verifique o download')
      } else {
        popup.document.write('Aguarde...')
      }
      const { data } = await apiRest.get(url, {
        responseType: 'arraybuffer',
        params: {
          churchId,
          status: printState.status,
          gender: printState.gender,
        },
      })

      const pdfURL = URL.createObjectURL(
        new Blob([data], { type: 'application/pdf' })
      )
      popup.location.href = pdfURL

      if (!matches) {
        // corrigir erro no android
        var fileLink = document.createElement('a')
        fileLink.href = pdfURL
        fileLink.download = 'pdf_name'
        fileLink.click()
        popup.document.write('arquivo baixado verifique o download')
      } else {
        setTimeout(() => {
          URL.revokeObjectURL(pdfURL)
          popup.print()
        }, 500)
      }
    }
  }
  return (
    <>
      <Dialog onClose={() => setOpenModalPrint(false)} open={isOpenModalPrint}>
        <DialogTitle>Relatório</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">Tipo</FormLabel>
            <RadioGroup
              row
              value={printState.gender}
              onChange={onChangePrintState('gender')}
            >
              <FormControlLabel
                value="all"
                control={<Radio color="primary" />}
                label="Todos"
              />
              <FormControlLabel
                value="Masculino"
                control={<Radio color="primary" />}
                label="Masculino"
              />
              <FormControlLabel
                value="Feminino"
                control={<Radio color="primary" />}
                label="Feminino"
              />
            </RadioGroup>
          </FormControl>
          <br />
          <FormControl component="fieldset" style={{ marginTop: 8 }}>
            <FormLabel component="legend">Status</FormLabel>
            <Select
              value={printState.status}
              displayEmpty
              onChange={onChangePrintState('status')}
            >
              <MenuItem value="" disabled>
                <em>Status</em>
              </MenuItem>
              {statusPeople.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
              <MenuItem value={'all'}>Todos</MenuItem>
            </Select>
            <FormHelperText>Imprimir por status dos membros</FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalPrint(false)}>Cancelar</Button>
          <Button onClick={onClickPrint} color="primary">
            Imprimir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
